import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-time-converter',
    templateUrl: './time-converter.component.html',
    standalone: false
})
export class TimeConverterComponent {
  @Input() label: string = 'Default Label';
  @Input() timeInMinutes: number | null = null; // Allow null value
  @Output() timeChange = new EventEmitter<number | null>(); // Emit updated time or null

  formattedTime: string = '';

  ngOnInit() {
    this.formattedTime = this.convertMinutesToTime(this.timeInMinutes);
  }

  ngOnChanges() {
    this.formattedTime = this.timeInMinutes !== null ? this.convertMinutesToTime(this.timeInMinutes) : '';
  }

  convertMinutesToTime(minutes: number | null): string {
    if (minutes === null) {
      return ''; // Show empty string for null
    }
    if (minutes === 0) {
      return '00:00'; // Show 00.00 for 0
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    // Default to '00' for minutes if not specified, but allow other values.
    return `${this.padZero(hours)}:${this.padZero(mins)}`;
  }

  convertTimeToMinutes(time: string): number | null {
    if (!time || time.split(':').length !== 2) {
      return null; // Return null if the input is empty or not a valid time string
    }
    const [hours, mins] = time.split(':').map(Number);
    if (isNaN(hours) || isNaN(mins)) {
      return null; // Return null if either hour or minute is not a number
    }
    return hours * 60 + mins;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  onTimeChange(event: any) {
    const newTime = this.convertTimeToMinutes(event.target.value); // Convert time to minutes or null
    this.timeChange.emit(newTime); // Emit updated time or null
  }

}
